import React from 'react';
import { Box, Link, Typography } from '@mui/material';

import { ICandidateDetails } from '@types';
import { formatDate } from '@utils';
import { Row } from './DetailFacts';

export const Provenance: React.FC<{ data: ICandidateDetails }> = ({ data }) => (
  <Box>
    {Boolean(data.submittedDate) && (
      <Row label="Submitted">
        <Typography variant="body1">
          {formatDate(data.submittedDate)}
        </Typography>
      </Row>
    )}
    {Boolean(data.submittedBy?.name || data.submittedBy?.email) && (
      <Row label="Sent by">
        <Typography variant="body1">{data.submittedBy?.name || '-'}</Typography>
        {Boolean(data.submittedBy?.email) && (
          <Link
            variant="body2"
            color="text.link"
            href={`mailto:${data.submittedBy?.email}`}
          >
            {data.submittedBy?.email}
          </Link>
        )}
      </Row>
    )}
  </Box>
);
